import { ProgressiveBarService } from './../../shared/progressive-bar/progressive-bar.service';
import { DataEntry } from './../../shared/data-entry.interface';
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { DataproviderService } from 'src/app/dataprovider.service';
import { TooltipTypesEnum } from 'src/app/shared/tooltip-types.enum';

@Component({
  selector: 'app-frame-shape',
  templateUrl: './frame-shape.component.html',
  styleUrls: ['./frame-shape.component.scss', './frame-shape.component.responsive.scss'],
  host: {
    class: 'd-block bg-standard p-b-104'
  }
})
export class FrameShapeComponent implements OnInit {

  title: string    = "b2c.IDS_FRAMESHAPE";
  subtitle: string = "b2c.IDS_FRAMESHAPE_SUB";
  showSubtitle: boolean = true;
  showSubtitleInfo: boolean = false;
  question: string = "b2c.IDS_FRAMESHAPE_QUE";
  activePage: string = "frameshape";
  nextPage: string = "coverconfigurator";

  dataEntries: DataEntry[] = [];

  constructor(
    private cs: CommonService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService,
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      false,
      null,
      null,
      false,
      null,
      true,
      this.showSubtitle,
      this.showSubtitleInfo
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(8);
  }

  ngOnInit() {
    this.initSelection();
  }

  initSelection() {
    this.dataEntries = this.ds.getDefaultShapes();
    let selectedDataEntry = this.ds.getShape();
    if (selectedDataEntry) {
      this.onSelectorClicked(selectedDataEntry.ID);
    }
  }

  dataEntriesUpdate(idSelected: number){
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data.ID == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number){
    this.dataEntriesUpdate(idSelected);
    this.ds.setShape(this.dataEntries.find(shp => {
      return shp.ID == idSelected;
    }));
  }
}
